import React from "react";
import UserInputMessageAreaThread from "./userInputMessageAreaThread";

const ThreadboardFooter = (props) => {
  const userInputMessageProps = { ...props, componentType: "footer" };
  return (
    <>
      <UserInputMessageAreaThread {...userInputMessageProps} />
    </>
  );
};

export default React.memo(ThreadboardFooter);
